import Lang from '@/core/lang';
import Reporting from '@/core/reporting';
import Toast from '@/core/toast/toast';
import Http from './http';
import Router from './router/router';

export const routerService = new Router();
export const httpService = new Http();
export const langService = new Lang();
export const toastService = new Toast();
export const reportService = new Reporting();
